import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { authContext } from '../provider/Context/AuthContext';

const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    const auth = useContext(authContext);

    return (
        <Route {...rest}
            render={({ location }) => {
                if (!auth.loggedIn) {
                    return <Redirect to={{ pathname: "/", state: { from: location } }} />
                }
                else if (roles && roles.indexOf(auth) == -1) {
                    return <Redirect to={{ pathname: '/' }} />
                }
                else {
                    return <Component />
                }

            }}
        />


    )
}
export default PrivateRoute;